import { openDB, type DBSchema, type IDBPDatabase } from 'idb';

import { ReviewAnnotationsPort, type ReviewAnnotation } from '../../application/ports';

interface ReviewDatabase extends DBSchema {
  readonly annotations: {
    readonly key: string;
    readonly value: ReviewAnnotation;
  };
}

export class IndexedDbReviewAnnotationsAdapter implements ReviewAnnotationsPort {
  private readonly database: Promise<IDBPDatabase<ReviewDatabase>>;

  constructor(databaseName = 'mon-testament-content-review') {
    this.database = openDB<ReviewDatabase>(databaseName, 1, {
      upgrade(database) {
        database.createObjectStore('annotations', { keyPath: 'ruleId' });
      },
    });
  }

  async load(): Promise<readonly ReviewAnnotation[]> {
    return (await (await this.database).getAll('annotations')).map((annotation) =>
      Object.freeze({ ...annotation }),
    );
  }

  async save(annotation: ReviewAnnotation): Promise<void> {
    await (await this.database).put('annotations', annotation);
  }
}
